module.exports = __webpack_public_path__ + "img/comida-china.e086c6df.jpg";